import { useState, useEffect } from "react";
import { useAuthContext } from "../../../hooks/useAuthContext";
import { DateTime } from "luxon";
import { Table, Pagination } from "react-bootstrap";
import { utilGetDocumentFilters } from "../../../util/UtilsFirebase";
import moment from "moment";
import { DateRangePicker } from "rsuite";
import "rsuite/dist/rsuite.css";
import "./QRChecador.css";
import { Button } from "react-bootstrap";
import { faPrint, faRefresh } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function QRChecador() {
  const { user, register } = useAuthContext();
  const [data, setData] = useState([]);
  const [dataChec, setDataChec] = useState([]);
  const [dateRange, setDateRange] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const elementsPerPage = 7;

  const getElementsForPage = (page) => {
    const startIndex = (page - 1) * elementsPerPage;
    const endIndex = startIndex + elementsPerPage;
    return dataChec.slice(startIndex, endIndex);
  };

  const handleDateRangeChange = async (datos) => {
    setDateRange(datos);
    refreshChecks();
  };

  const clickDateRangeChange = (datos) => {
    refreshChecks();
  };

  const refreshChecks = () => {
    console.log(dateRange);

    if (dateRange) {
      console.log(dateRange[0]);
      console.log(dateRange[1]);

      const filtros = [
        { campo: "puesto", operador: "==", valor: register.id },
        { campo: "start_date", operador: ">=", valor: dateRange[0] },
        { campo: "start_date", operador: "<=", valor: dateRange[1] },
      ];

      const fetchChec = utilGetDocumentFilters("checador", filtros);

      fetchChec
        .then((fetchedChecs) => {
          console.log(fetchedChecs);

          setDataChec(fetchedChecs);
        })
        .catch((error) => {
          console.error("Error fetching checs:", error);
        });
    } else {
      const localTimeZone = "America/Hermosillo"; // Zona horaria de Nogales, Sonora
      const currentDate = DateTime.now().setZone(localTimeZone);
      const startOfDay = currentDate.startOf("day");
      const endOfDay = currentDate.endOf("day");

      const filtros = [
        { campo: "puesto", operador: "==", valor: register.id },
        { campo: "start_date", operador: ">=", valor: startOfDay.toJSDate() },
        { campo: "start_date", operador: "<=", valor: endOfDay.toJSDate() },
      ];

      const fetchChec = utilGetDocumentFilters("checador", filtros);

      fetchChec
        .then((fetchedChecs) => {
          console.log(fetchedChecs);

          setDataChec(fetchedChecs);
        })
        .catch((error) => {
          console.error("Error fetching checs:", error);
        });
    }
  };

  useEffect(() => {
    console.log(register);
    //Remove api https://chart.googleapis.com/chart?chs=150x150&cht=qr&chl=
    var qrText =
      "https://quickchart.io/qr?text=C-" +
      register.id +
      "-" +
      register.admin.id;
    var info = {
      id: 1,
      nombre: "QR CHECADOR",
      qr: qrText,
    };
    setData([info]);

    refreshChecks();
  }, [dateRange]);

  const printQR = () => {
    var content = document.getElementById("project-qr");
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  };

  return (
    <div className="container">
      <iframe className="iframePrint" id="ifmcontentstoprint"></iframe>
      <br />

      <h4 className="page-title">CHECADOR</h4>
      <br />

      <div className="row">
        <div className="col-6">
          <div id="project-qr" className="row">
            {data.map((n, key) => (
              <div key={key} className="center">
                <a>
                  <img className="qr-code" src={n.qr}></img>
                  <div className="center">{n.nombre}</div>
                </a>
              </div>
            ))}
          </div>
          <hr />

          <div className="center-form" onClick={printQR}>
            <Button variant="primary" className="button" type="button">
              <FontAwesomeIcon icon={faPrint} /> IMPRIMIR
            </Button>
          </div>
        </div>

        <div className="col-6">
          <div>
            <div>
              <DateRangePicker
                onChange={handleDateRangeChange}
                appearance="default"
                placeholder="Filtar por rango de fechas"
              />

              <Button
                variant="primary"
                onClick={() => clickDateRangeChange(null)}
                className="button"
                type="button"
              >
                <FontAwesomeIcon icon={faRefresh} />
              </Button>
            </div>
          </div>
          <br />

          <Table striped bordered hover border="2">
            <thead>
              <tr>
                <th>Usuario</th>
                <th>Puesto</th>
                <th>Inicio</th>
                <th>Fin</th>
              </tr>
            </thead>
            <tbody>
              {getElementsForPage(currentPage)
                .sort()
                .map((val, key) => {
                  return (
                    <tr key={key}>
                      <td>{val.user_name}</td>
                      <td>{val.puesto_name}</td>
                      <td>
                        {moment(val.start_date.toDate()).format(
                          "DD/MM/YYYY hh:mm a zzz",
                        )}
                      </td>
                      <td>
                        {val.end_date != null
                          ? moment(val.end_date.toDate()).format(
                              "DD/MM/YYYY hh:mm a zzz",
                            )
                          : ""}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
          <Pagination>
            {Array.from({
              length: Math.ceil(dataChec.length / elementsPerPage),
            }).map((page, index) => (
              <Pagination.Item
                key={index}
                active={index + 1 === currentPage}
                className={index + 1 === currentPage ? "btn-paginado" : ""}
                onClick={() => setCurrentPage(index + 1)}
              >
                {index + 1}
              </Pagination.Item>
            ))}
          </Pagination>
        </div>
      </div>
    </div>
  );
}
